import { Classification } from '@lastbrand/storefront-proto-registry'

import { BUILD_ENVIRONMENTS } from '@src/config/constants'
import { CONFIG_BUILD_ENV } from '@src/config/env'
import {
  QA_CLASS_ID,
  CLASS_ID,
  QA_SUB_DEPARTMENT_ID,
  SUB_DEPARTMENT_ID,
} from '@src/quince-site-common/src/helpers/productHelper'

export const isProductDogFood = (classification: Classification | undefined) => {
  const classId = classification?.class?.id

  if (CONFIG_BUILD_ENV === BUILD_ENVIRONMENTS.QA) {
    return classId === QA_CLASS_ID.DOG_FOOD
  }
  return classId === CLASS_ID.DOG_FOOD
}

export const isProductVitamin = (classification: Classification | undefined) => {
  const subDepartmentId = classification?.subDepartment?.id

  if (CONFIG_BUILD_ENV === BUILD_ENVIRONMENTS.QA) {
    return subDepartmentId === QA_SUB_DEPARTMENT_ID.VITAMINS
  }
  return subDepartmentId === SUB_DEPARTMENT_ID.VITAMINS
}

export const shouldShowPricePerUnit = (classification: Classification | undefined) => {
  const isVitamin = isProductVitamin(classification)
  const isDogFood = isProductDogFood(classification)
  return isVitamin || isDogFood
}
